import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { galesburgConfig } from "./data";

export default function GalesburgPage() {
  return <CityPageTemplate config={galesburgConfig} />;
}